import { render, staticRenderFns } from "./SidebarStatic.vue?vue&type=template&id=93630894&"
import script from "./SidebarStatic.vue?vue&type=script&lang=js&"
export * from "./SidebarStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports